<template>
  <div class="conten">
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true">
        <el-form-item>
          <el-input v-model="secah.tel" placeholder="请输入商家电话号码"></el-input>
        </el-form-item>
        <el-form-item label="申报状态" label-width='70px'>
          <el-select clearable v-model="secah.shopStatus" placeholder="请选择申报状态">
            <el-option label="全部" value=""></el-option>
            <el-option label="申请中" :value="1"></el-option>
            <el-option label="申请通过" :value="2"></el-option>
            <el-option label="申请失败" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="注销状态" label-width='70px'>
          <el-select clearable v-model="secah.cancelState" placeholder="请选择注销状态">
            <el-option label="全部" value=""></el-option>
            <el-option label="未注销" :value="0"></el-option>
            <el-option label="已注销" :value="1"></el-option>
            <el-option label="审核中" :value="2"></el-option>
            <el-option label="审核不通过" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click='secahClick'>搜索</el-button>
        </el-form-item>

      </el-form>
    </el-col>

    <div>
      <el-table :data="tableData" style="width: 100%" border>
        <el-table-column prop="shopName" label="店铺名称" align="center"></el-table-column>
        <el-table-column prop="bossFullName" label="真实姓名" align="center"></el-table-column>
        <el-table-column label="申报状态" align="center">
          <template slot-scope="scope">
            {{scope.row.shopStatus==1?"申请中":scope.row.shopStatus==2?"申请通过":"申请失败"}}
          </template>
        </el-table-column>
        <el-table-column label="服务费" align="center">
          <template slot-scope="scope">
            {{scope.row.platformServiceFee==1?"60%":scope.row.platformServiceFee==2?"80%":"100%"}}
          </template>
        </el-table-column>
        <el-table-column label="申请更换服务费" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.platformServiceFeeStatus==2">
              {{scope.row.platformServiceFeeNew==1?"60%":scope.row.platformServiceFeeNew==2?"80%":"100%"}}
            </div>
            <div></div>
          </template>
        </el-table-column>
        <el-table-column prop="tel" label="联系电话" align="center"></el-table-column>
        <el-table-column prop="address" width="220" label="地址" align="center"></el-table-column>
        <el-table-column prop="averagePrice" label="单人价格" align="center"></el-table-column>
        <el-table-column prop="openingHours" label="开始营业时间" align="center"></el-table-column>
        <el-table-column prop="closingHours" label="结束营业时间" align="center"></el-table-column>
        <el-table-column prop="createTime" label="入驻时间" align="center"></el-table-column>
        <el-table-column prop="tagName" label="标签名" align="center"></el-table-column>
        <el-table-column prop="regionName" label="地区名" align="center"></el-table-column>
        <el-table-column prop="cancelState" label="注销状态" align="center">
          <template slot-scope="scope">
            {{getCancelState(scope.row.cancelState)}}
          </template>
        </el-table-column>
        <el-table-column prop="shopNameNew" label="新店铺名称" align="center"></el-table-column>
        <el-table-column prop="doorFaceImgNew" label="新门脸图" align="center">
          <template slot-scope="scope">
            <viewer>
              <img :src="webUrl+scope.row.doorFaceImgNew" style="width: 60px;" />
            </viewer>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="220" align="center">
          <template slot-scope="scope">
            <el-button type="success" v-if="scope.row.shopStatus==1" size="mini" @click="agreeWithdrawal(scope.row)">申请通过</el-button>
            <el-button type="danger" v-if="scope.row.shopStatus==1" size="mini" @click="refuseWithdrawal(scope.row)">拒绝申请</el-button>

            <el-button type="success" v-if="scope.row.platformServiceFeeStatus==2" size="mini" @click="agreeChangePlatformServiceFee(scope.row)">同意更改服务费</el-button>
            <el-button type="danger" v-if="scope.row.platformServiceFeeStatus==2" size="mini" @click="refuseChangePlatformServiceFee(scope.row)">拒绝更改服务费</el-button>

            <el-button type="success" v-if="scope.row.shopNameNewStatus==2" size="mini" @click="agreeChangeShopName(scope.row)">同意更改名称头像</el-button>
            <el-button type="danger" v-if="scope.row.shopNameNewStatus==2" size="mini" @click="refuseChangeShopName(scope.row)">拒绝更改名称头像</el-button>

            <el-button type="primary" style="margin-top: 10px;" size="mini" @click="dertails(scope.row)">详情
            </el-button>
            <el-button type="primary" v-if="scope.row.cancelState != 1" style="margin-top: 10px;" size="mini" @click="del(scope.row)">强制注销
            </el-button>

            <el-button v-if="scope.row.cancelState == 2" type="primary" style="margin-top: 10px;" size="mini" @click="cancle(scope.row, 3)">拒绝注销
            </el-button>
            <el-button v-if="scope.row.cancelState == 2" type="primary" style="margin-top: 10px;" size="mini" @click="cancle(scope.row, 1)">同意注销
            </el-button>
            <!-- <el-button size="mini" @click="edit(scope.row)">编辑</el-button>
						<el-button size="mini" type="danger" @click="del(scope.row)">删除</el-button>
						<el-button size="mini" type="warning" @click="reset(scope.row)">重置密码</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="secah.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="secah.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
    <el-dialog :close-on-click-modal='false' :close-on-press-escape='false' title="拒绝原因" :visible.sync="isreason" :modal-append-to-body='false' width="600px">
      <el-form>
        <el-form-item label="拒绝原因" label-width='80px'>
          <el-input type="textarea" v-model="reason" maxlength="10" autocomplete="off" placeholder="请输入拒绝原因">
          </el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isreason = false">取 消</el-button>
        <el-button type="primary" @click="sub">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal='false' :close-on-press-escape='false' title="详情" :visible.sync="isDetails" :modal-append-to-body='false' width="800px">

      <el-descriptions :column='2'>
        <el-descriptions-item label="店铺名称">{{detailsData.shopName}}</el-descriptions-item>
        <el-descriptions-item label="真实姓名">{{detailsData.bossFullName}}</el-descriptions-item>
        <el-descriptions-item label="申报状态">{{detailsData.shopStatus==1?"申请中":detailsData.shopStatus==2?"申请通过":"申请失败"}}</el-descriptions-item>
        <el-descriptions-item label="赠送商家积分">{{detailsData.platformServiceFee==1?"60%":detailsData.platformServiceFee==2?"80%":"100%"}}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{detailsData.tel}}</el-descriptions-item>
        <el-descriptions-item label="地址">{{detailsData.address}}</el-descriptions-item>
        <el-descriptions-item label="单人价格">{{detailsData.averagePrice}}</el-descriptions-item>
        <el-descriptions-item label="开始营业时间">{{detailsData.openingHours}}</el-descriptions-item>
        <el-descriptions-item label="结束营业时间">{{detailsData.closingHours}}</el-descriptions-item>
        <el-descriptions-item label="入驻时间">{{detailsData.createTime}}</el-descriptions-item>
        <el-descriptions-item label="标签名">{{detailsData.tagName}}</el-descriptions-item>
        <el-descriptions-item label="地区名">{{detailsData.regionName}}</el-descriptions-item>
        <el-descriptions-item label="店铺自评">{{detailsData.selfAssessment}}</el-descriptions-item>

      </el-descriptions>
      <div style="display: flex;margin-bottom: 20px;">
        <div style="flex: 1;display: flex;">
          <span> 身份证正面</span>
          <viewer>
            <img :src="webUrl+detailsData.legalPersonFront" style="width: 150px;height: 120px;margin-left: 10px;" />
          </viewer>

        </div>
        <div style="flex: 1;display: flex;">
          <span> 身份证反面</span>
          <viewer>
            <img :src="webUrl+detailsData.legalPersonBack" style="width: 150px;height: 120px;margin-left: 10px;" />
          </viewer>
        </div>
      </div>

      <div style="display: flex;margin-bottom: 20px;">
        <div style="flex: 1;display: flex;">
          <span> 营业执照</span>
          <viewer>
            <img :src="webUrl+detailsData.businessLicense" style="width: 150px;height: 120px;margin-left: 10px;" />
          </viewer>

        </div>
        <div style="flex: 1;display: flex;">
          <span> 定位截图</span>
          <viewer>
            <img :src="webUrl+detailsData.addrImg" style="width: 150px;height: 120px;margin-left: 10px;" />
          </viewer>
        </div>
      </div>
      <div style="display: flex;margin-bottom: 20px;">
        <div style="flex: 1;display: flex;">
          <span> 门脸图</span>
          <viewer>
            <img :src="webUrl+detailsData.doorFaceImg" style="width: 150px;height: 120px;margin-left: 10px;" />
          </viewer>

        </div>
        <div style="flex: 1;display: flex;">
          <span> 环境图</span>
          <viewer>
            <img :src="webUrl+detailsData.environmentImg" style="width: 150px;height: 120px;margin-left: 10px;" />
          </viewer>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="success" v-if="detailsData.shopStatus==1" size="mini" @click="agreeWithdrawal(detailsData)">申请通过</el-button>
        <el-button type="danger" v-if="detailsData.shopStatus==1" size="mini" @click="refuseWithdrawal(detailsData)">拒绝申请</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      total: 0,
      isreason: false,
      reason: '',
      secah: {
        pageSize: 10,
        pageNum: 1,
        shopStatus: '',
        tel: '',
        cancelState: '',
      },
      shopId: '',
      detailsData: {},
      isDetails: false,
    }
  },
  created() {
    this.getList()
  },
  methods: {
    //搜索
    secahClick() {
      this.secah.pageNum = 1
      this.getList()
    },
    getCancelState(state) {
      if (state == 0) {
        return '未注销'
      } else if (state == 1) {
        return '已注销'
      } else if (state == 2) {
        return '审核中'
      } else if (state == 3) {
        return '审核不通过'
      }
    },
    //通过商家审核
    agreeWithdrawal(row) {
      this.$confirm('确定通过当前申请?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.httpPost('/pc/shop/agree?shopId=' + row.shopId).then((res) => {
            if (res.code == 200) {
              this.$message.success('操作成功')
              this.isDetails = false
              this.dialogVisible = false
              this.getList()
              // this.getUserList()
            }
          })
        })
        .catch(() => {})
    },
    //拒绝通过商家审核
    refuseWithdrawal(row) {
      this.isreason = true
      this.shopId = row.shopId
      this.reason = ''
    },
    //确定拒绝通过商家审核
    sub() {
      this.httpPost(
        '/pc/shop/refuse?shopId=' + this.shopId + '&reason=' + this.reason
      ).then((res) => {
        if (res.code == 200) {
          this.$message.success('操作成功')
          this.isreason = false
          this.isDetails = false
          this.getList()

          // this.getUserList()
        }
      })
    },
    //同意更改服务费
    agreeChangePlatformServiceFee(row) {
      this.$confirm('确定通过当前申请更换服务费?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.httpPost(
            '/pc/shop/agreeChangePlatformServiceFee?shopId=' + row.shopId
          ).then((res) => {
            if (res.code == 200) {
              this.$message.success('操作成功')
              // this.isDetails=false
              // this.dialogVisible = false
              this.getList()
              // this.getUserList()
            }
          })
        })
        .catch(() => {})
    },
    //拒绝更改服务费
    refuseChangePlatformServiceFee(row) {
      this.$confirm('确定拒绝当前申请更换服务费?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.httpPost(
            '/pc/shop/refuseChangePlatformServiceFee?shopId=' + row.shopId
          ).then((res) => {
            if (res.code == 200) {
              this.$message.success('操作成功')
              // this.isDetails=false
              // this.dialogVisible = false
              this.getList()
              // this.getUserList()
            }
          })
        })
        .catch(() => {})
    },
    agreeChangeShopName(row) {
      this.$confirm('确定通过当前申请更换店铺名称与头像?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.httpPost(
            '/pc/shop/agreeChangeShopName?shopId=' + row.shopId
          ).then((res) => {
            if (res.code == 200) {
              this.$message.success('操作成功')
              this.getList()
            }
          })
        })
        .catch(() => {})
    },
    refuseChangeShopName(row) {
      this.$confirm('确定拒绝通过当前申请更换店铺名称与头像?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.httpPost(
            '/pc/shop/refuseChangeShopName?shopId=' + row.shopId
          ).then((res) => {
            if (res.code == 200) {
              this.$message.success('操作成功')
              this.getList()
            }
          })
        })
        .catch(() => {})
    },
    dertails(row) {
      this.isDetails = true
      this.detailsData = row
    },
    del(row) {
      this.$confirm('确定注销店铺?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.httpPost('/pc/shop/adminCancel?shopId=' + row.shopId).then(
          (res) => {
            if (res.code == 200) {
              this.$message.success('操作成功')
              // this.isDetails=false
              // this.dialogVisible = false
              this.getList()
              // this.getUserList()
            }
          }
        )
      })
    },
    cancle(row, cancelState) {
      this.$confirm(
        '确定' + (cancelState == 1 ? '同意' : '拒绝') + '注销店铺?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(() => {
        this.httpPost(
          '/pc/shop/adminAuditCancel?cancelState=' +
            cancelState +
            '&shopId=' +
            row.shopId
        ).then((res) => {
          if (res.code == 200) {
            this.$message.success('操作成功')
            this.getList()
          }
        })
      })
    },

    //选择分页条数
    handleSizeChange(e) {
      this.secah.pageNum = 1
      this.secah.pageSize = e
      this.getList()
    },
    //页码
    handleCurrentChange(e) {
      this.secah.pageNum = e
      this.getList()
    },
    //获取数据
    getList() {
      var secah = this.secah
      // secah.withdrawalStatus=secah.withdrawalStatus?secah.withdrawalStatus:0
      this.httpPost('/pc/shop/listByPage', secah, true, {
        'Content-Type': 'application/json',
      }).then((res) => {
        if (res.code == 200) {
          this.tableData = res.data.content
          this.total = res.data.total
        }
      })
    },
  },
}
</script>

<style scoped lang='scss'>
.page {
  padding: 20px 0;
}
</style>
